import React from "react";

const DashboardHome = () => {
  return (
    <div>
      <h1 className="my-5 text-center fw-bold  bg-warning rounded ">Dash<span className="text-white">board</span> </h1>
    </div>
  );
};

export default DashboardHome;
